///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component } from '@angular/core';

@Component({
    selector: 'winde-error',
    templateUrl: './error.component.html',
    standalone: false
})
export class ErrorComponent {
    errorMessage: string;
    error403: boolean;
}
